import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusTone } from '../../StatusBadge.js';
import classes from './Materials.module.css';
import type { StockStatus } from './types.js';

const TYPE_TONE: Record<string, StatusTone> = {
  Consumable: 'info',
  // Tasarımda "Spare Part" turuncu rozet (`satin-alma-akisi.jpeg` "Material Detail"); ölçülen ton
  // warning ailesinde, ayrı turuncu token yok (ADR 0033 §2)
  'Spare Part': 'warning',
  'Equipment/Spare': 'neutral',
  // Kumanya kalemi (ADR 0099 §4)
  Provision: 'success',
};

export function MaterialTypeBadge({ type }: { type: string }) {
  const { t } = useTranslation();
  return (
    <StatusBadge tone={TYPE_TONE[type] ?? 'neutral'}>
      {t(`materials.types.${type}`, { defaultValue: type })}
    </StatusBadge>
  );
}

export const STOCK_TONE: Record<StockStatus, StatusTone> = {
  normal: 'success',
  low: 'warning',
  critical: 'danger',
};

/** Rozetin 7 px noktası; renk rozetin tonundan (`--tone-mark`). */
const dot = <span className={classes.badgeDot} data-dot />;

/**
 * Stok durumu rozeti. Stock Management tablosunda "OK" / "Low Stock" (`satin-alma-akisi.jpeg`):
 * OK noktasız ve ince kenarlı, Low Stock ve Critical noktalı (M6f G5-23). Envanter listesinde
 * "● Normal" / "● Low" / "● Critical" (`gemi-envanter-kumanya.jpeg`): hepsi noktalı, yazı 500
 * (G5-49).
 */
export function StockStatusBadge({
  status,
  variant = 'inventory',
}: {
  status: StockStatus;
  variant?: 'inventory' | 'management';
}) {
  const { t } = useTranslation();
  const label = t(`stock.status.${variant}.${status}`);
  if (variant === 'management' && status === 'normal') {
    return (
      <StatusBadge tone="success" outlined>
        {label}
      </StatusBadge>
    );
  }
  const badge = (
    <StatusBadge tone={STOCK_TONE[status]} icon={dot}>
      {label}
    </StatusBadge>
  );
  return variant === 'inventory' ? <span className={classes.inventoryBadge}>{badge}</span> : badge;
}
